import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { createUserStorage } from './userStorage'

const PINNED_ITEMS_STORE_KEY = 'pinned-items-store'

interface PinnedItemsStoreState {
  pinnedSpaces: string[]
  pinnedProjects: string[]
}

const INITIAL_PINNED_ITEMS_STORE: PinnedItemsStoreState = {
  pinnedSpaces: [],
  pinnedProjects: [],
}

export const usePinnedItemsStore = create<PinnedItemsStoreState>()(
  persist(() => INITIAL_PINNED_ITEMS_STORE, {
    name: PINNED_ITEMS_STORE_KEY,
    storage: createUserStorage(),
  }),
)

export const togglePinnedSpace = (spaceId: string) => {
  usePinnedItemsStore.setState((state) => {
    const isPinned = state.pinnedSpaces.includes(spaceId)

    return {
      pinnedSpaces: isPinned
        ? state.pinnedSpaces.filter((id) => id !== spaceId)
        : [...state.pinnedSpaces, spaceId],
    }
  })
}

export const togglePinnedProject = (projectId: string) => {
  usePinnedItemsStore.setState((state) => {
    const isPinned = state.pinnedProjects.includes(projectId)

    return {
      pinnedProjects: isPinned
        ? state.pinnedProjects.filter((id) => id !== projectId)
        : [...state.pinnedProjects, projectId],
    }
  })
}

export const untogglePinnedSpace = (spaceId: string) =>
  usePinnedItemsStore.setState((state) => ({
    pinnedSpaces: state.pinnedSpaces.filter((id) => id !== spaceId),
  }))

export const untogglePinnedProject = (projectId: string) =>
  usePinnedItemsStore.setState((state) => ({
    pinnedProjects: state.pinnedProjects.filter((id) => id !== projectId),
  }))

export const usePinnedSpaces = () =>
  usePinnedItemsStore((state) => state.pinnedSpaces)
export const usePinnedProjects = () =>
  usePinnedItemsStore((state) => state.pinnedProjects)
export const useIsSpacePinned = (spaceId: string) =>
  usePinnedItemsStore((state) => state.pinnedSpaces.includes(spaceId))
export const useIsProjectPinned = (projectId: string) =>
  usePinnedItemsStore((state) => state.pinnedProjects.includes(projectId))

export const rehydratePinnedItemsStore = () =>
  usePinnedItemsStore.persist.rehydrate()

export const resetPinnedItemsStore = () =>
  usePinnedItemsStore.setState({ pinnedSpaces: [], pinnedProjects: [] }, true)
